import { observer } from "mobx-react-lite";

import { useTheme } from "@bps/fluent-ui";
import { Permission } from "@libs/gateways/core/CoreGateway.dtos.ts";
import { ContactType } from "@libs/gateways/practice/PracticeGateway.dtos.ts";
import { useStores } from "@stores/hooks/useStores.ts";
import { usePatientLabel } from "@ui-components/hooks/usePatientLabel.ts";
import { Nav } from "@ui-components/navigation/Nav.tsx";

import { useAddContactLink } from "./hooks/useAddContactLink.ts";
import { useAppointmentLink } from "./hooks/useAppointmentLink.ts";
import { useNewInvoiceLink } from "./hooks/useNewInvoiceLink.ts";
import { useNewPaymentLink } from "./hooks/useNewPaymentLink.ts";

export const MoreNavButton = observer(() => {
  const { core } = useStores();

  const theme = useTheme();

  const patientLabel = usePatientLabel();

  if (
    !core.hasPermissions([
      Permission.InvoiceCreate,
      Permission.PaymentCreate,
      Permission.PreReleaseAccInvoices,
      Permission.AccountHistoryAllowed
    ]) &&
    !core.hasPermissions([
      Permission.ContactRead,
      Permission.ContactWrite,
      Permission.PatientRead,
      Permission.PatientWrite
    ]) &&
    !core.hasPermissions(
      [Permission.InvoiceCreate, Permission.PaymentCreate],
      "or"
    )
  ) {
    return null;
  }

  return (
    <Nav
      renderAsButton
      buttonProps={{
        hideChevron: true,
        iconProps: { iconName: "add" },
        gapSpace: 12,
        buttonStyles: {
          root: {
            height: 24,
            width: 24,
            minWidth: 24,
            alignSelf: "center",
            border: `1px solid ${theme.palette.white}`,
            borderRadius: 4
          },
          icon: { fontSize: 12 },
          menuIcon: { display: "none" }
        }
      }}
      links={[
        useAppointmentLink(),
        useAddContactLink(ContactType.Patient, { name: `New ${patientLabel}` }),
        useAddContactLink(ContactType.Individual, {
          name: `New non-${patientLabel}`
        }),
        useAddContactLink(ContactType.Organisation, {
          name: "New organisation",
          showBorder: true
        }),
        useNewInvoiceLink(),
        useNewPaymentLink()
      ]}
    />
  );
});
